export const SettingsActors = {
    TOGGLE_SETTINGS:'TOGGLE_SETTINGS',
    SETTINGS_LIST:'SETTINGS_LIST'
}